// Dependencies
import React, { useRef } from "react";

// Helpers
import useMathJaxParser from "hooks/use-math-jax-parser";

interface IProps {
    enunciation: string;
}

const Enunciation = ({ enunciation }: IProps) => {
    const contentRef = useRef<HTMLDivElement>(null);

    // Load parser
    useMathJaxParser(contentRef);

    const enunciationImage = enunciation.replace(/<img/g, "<img onclick='window.showImage(this)'");

    return <div className="ck-content" dangerouslySetInnerHTML={{ __html: enunciationImage }} ref={contentRef} />;
};

export default React.memo(Enunciation);
